// extracted by mini-css-extract-plugin
module.exports = {"bizbookMenu":"bizbookMenu_bizbookMenu__16jHN","bizbookMenuItem":"bizbookMenu_bizbookMenuItem__2EQ7-","bizbookMenuItemLogout":"bizbookMenu_bizbookMenuItemLogout__3ZdlJ"};